/**
 * 浏览器环境相关
 */

const UA = navigator.userAgent

export const isHttps = window.location.protocol === 'https:'

export const isHttp = window.location.protocol === 'http:'

const androidInfo = UA.match(/Android ([\d.]+)/i)

export const isBadAndroid = androidInfo && androidInfo[1] < '4.4'

export const isAndroid = /Android/i.test(UA)

export const isIOS = /iphone|ipad|ipod|ios/i.test(UA)

export function getOSInfo() {
  if (/win/i.test(UA)) return 'window'
  if (/mac/i.test(UA)) return 'mac'
  if (/Android/i.test(UA)) return 'android'
  if (/iphone|ipad|ipod|ios/i.test(UA)) return 'ios'
}
// 判断是PC或手机端 true为手机端 false为PC端
export function IsMobileBased() {
  if (navigator.userAgent.indexOf('Soda.Manager') > -1) {
    return true
  } else {
    return false
  }
}

export function isFlutterEnv() {
  return UA.indexOf('BDApp FlutterWebView') > -1
}
